const state = {
    token: null, //访问码
    action: false,
    user_name: '',
    tab_name: 'one',
    cache_data: {},
    permission: {},
    talgIndex: 0
};
export default state;



// WEBPACK FOOTER //
// ./src/store/state.js